// Dependecies
import { createStore, createHook } from 'react-sweet-state';

// Helpers
import { findIndexBySlug } from '../helpers';

const initialState = {
  itemsTerms: [],
  termsPages: [],
};

const actions = {
  getTermsAndConditions:
    () =>
    async ({ setState }) => {
      const response = await fetch(`/api/bread/pages/static/get_all_terms`);
      const newTerms = await response.json();

      if (response.status === 200) {
        setState({ itemsTerms: newTerms });
      }
    },
  getTermBySlug:
    (slug, locale) =>
    async ({ getState, setState }) => {
      const response = await fetch(
        `/api/bread/pages/static/get_by_slug?slug=${slug}&lang=${locale}`
      );
      const term = await response.json();

      if (response.status === 200) {
        const termsPages = [...getState().termsPages];
        const index = findIndexBySlug(termsPages, locale, slug);

        if (index >= 0) {
          termsPages[index] = term;
        } else {
          termsPages.push(term);
        }
        setState({ termsPages });
      }
    },
};

const Store = createStore({
  initialState,
  actions,
  name: 'termsAndCondictions',
});

export default createHook(Store);
